export default "__VITE_ASSET__759b4c4c__"